import { fetchArrayOfObjects } from '@api/api_calls'
import { noModelSelected } from '@containers/admin/User/ThreeDModelSelector'
import useApi from '@hooks/useApi'
import { isString } from 'lodash'

export type ThreeDModelType = 'main' | 'demo'

export default function use3dApi () {
  const { apiPost, apiPut, apiDelete } = useApi()

  const getModelNames = async () => {
    const names = await fetchArrayOfObjects<string>('api/3d/model/names', 'Could not fetch model names')
    return names.filter(name => isString(name) && !!name)
  }

  const saveModelName = (type: ThreeDModelType, name: string) => {
    let url: string = ''

    if (type === 'main') {
      url = '/api/3d/model/name'
    } else if (type === 'demo') {
      url = '/api/3d/model/demo/name'
    } else {
      return Promise.reject(new Error('Invalid model type'))
    }

    return apiPut(
      url,
      { name },
      {
        successMessage: name === noModelSelected ? 'No 3D model selected' : `Saved 3D model name "${name}"`,
        errorMessage: `Could not save 3D model name "${name}"`
      }
    ).then(() => ({ ok: true }))
  }

  const deleteModel = (name: string) => apiDelete('/api/3d/model', { name })

  const uploadModel = (formData: FormData, successMessage: string) =>
    void apiPost('/api/3d/model', formData, {
      successMessage,
      rethrowError: true
    })

  return { getModelNames, saveModelName, deleteModel, uploadModel }
}
